export default __webpack_public_path__ + "static/consistent-header-current-section-872cac0221e0f76f8bd01660e3adab0f.png";